<template>
    <span ref="input" class="ah-el-input-invoice">
        <el-input
            v-model.trim="inputVal"
            class="input"
            :disabled="disabled"
            style="width: 220px"
            :maxlength="10"
            :show-word-limit="true"
            @paste.native.capture="onPaste"
            @blur="onCheckValidateInvoice"
        />
        <div v-if="showDuplicateHint" class="duplicate-hint">
            <i v-if="isCheckingInvoice" class="el-icon-loading" />
            <template v-else-if="isChecked">
                <i v-if="!numberUsedList" class="el-icon-check" style="margin-top: 6pt" />
                <el-alert v-else type="warning" size="small" :closable="false" class="small-alert"> 此號碼已存在，發票單號：{{ numberUsedList }} </el-alert>
            </template>
        </div>
    </span>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
    name: 'ah-el-input-invoice',
    props: {
        value: {
            type: String,
            default: null,
        },
        checkDate: {
            type: Number,
            default: null,
        },
        ioo: {
            type: String,
            default: null,
        },
        disabled: Boolean,
        showDuplicateHint: Boolean,
    },
    data() {
        return {
            isPaste: false,
            isCheckingInvoice: false,
            numberUsedList: false,
            isChecked: false,
        };
    },
    mounted() {
        this.onCheckValidateInvoice();
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                const converted = this.getConverted(val);
                this.$emit('input', converted);
                if (val?.length < 10) this.isChecked = false;
            },
        },
    },
    methods: {
        onPaste() {
            this.isPaste = true;
            setTimeout(() => {
                this.isPaste = false;
            }, 10);
        },
        matchType(letter, index) {
            if (!letter || index > 9) return false;

            const inputNumberFormat = Number(letter);
            const isText = Number.isNaN(inputNumberFormat);
            const ASCII = Number(letter.codePointAt(0));
            const isValidateText = (ASCII >= 97 && ASCII <= 122) || (ASCII >= 65 && ASCII <= 90) || (ASCII >= 65313 && ASCII <= 65338);
            const isNumber = !Number.isNaN(inputNumberFormat);

            if (isNumber && index > 1) return true;
            if (isText && isValidateText && index < 2) return true;
            return false;
        },
        getUpperCase(letter) {
            const ASCII = letter.codePointAt(0);
            const isFullWidth = ASCII >= 65313 && ASCII <= 65338;
            const FORMATTED = String.fromCodePoint(isFullWidth ? ASCII - 65248 : ASCII);

            return FORMATTED.toUpperCase();
        },
        getConverted(input) {
            let letterList = input.split('');
            if (this.isPaste) letterList = letterList.filter((o) => o !== '-');
            const newList = [];

            letterList.forEach((letter, index) => {
                if (!this.matchType(letter, index)) {
                    this.shake();
                    return;
                }
                newList.push(this.getUpperCase(letter));
            });
            return newList.join('');
        },

        shake() {
            if (this.isPaste) return;

            this.$refs.input.classList.add('shake');
            this.$refs.input.classList.add('shake-constant');
            setTimeout(() => {
                this.$refs.input.classList.remove('shake');
                this.$refs.input.classList.remove('shake-constant');
            }, 150);
        },
        async onCheckValidateInvoice() {
            if (!this.value || this.value.length < 10 || !this.checkDate || !this.showDuplicateHint) return;
            try {
                this.isCheckingInvoice = true;
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/QueryAuidingInvoice',
                    params: {
                        foo: this.value,
                        year: moment(this.checkDate).year(),
                    },
                    method: 'GET',
                });
                this.numberUsedList = _.chain(resp.data.items)
                    .filter((o) => (o.tranInvoice ? o.tioo !== this.ioo : o.ioo !== this.ioo))
                    .map((o) => (o.tranInvoice ? o.tioo : o.ioo))
                    .value()
                    .join('、');
            } finally {
                this.isCheckingInvoice = false;
                this.isChecked = true;
            }
        },
    },
};
</script>
<style lang="scss">
.ah-el-input-invoice {
    .el-input input {
        letter-spacing: 1px;
        font-weight: bold;
        font-size: 12pt;
    }
    .duplicate-hint {
        display: inline-block;
        margin-left: 10px;
        line-height: 10px;
        vertical-align: top;
        .small-alert {
            padding: 10px;
            p {
                margin-top: 0;
            }
        }
    }
}
</style>
